import * as React from 'react';

function ErrorExclamationTriangle() {
    return (React.createElement("svg", { height: "20", viewBox: "0 0 23 20", width: "23", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M22.741 17.188c.737 1.25-.188 2.812-1.66 2.812H1.919C.444 20-.477 18.435.259 17.188L9.839.937c.738-1.25 2.585-1.248 3.321 0l9.581 16.251zM11.5 13.828c-1.014 0-1.837.805-1.837 1.797 0 .992.823 1.797 1.837 1.797s1.837-.805 1.837-1.797c0-.992-.823-1.797-1.837-1.797zM9.756 7.37l.296 5.313a.475.475 0 00.479.443h1.938a.475.475 0 00.479-.443l.296-5.313a.473.473 0 00-.479-.494h-2.53a.473.473 0 00-.479.494z", fill: "#CD1F1F", fillRule: "evenodd" })));
}

export { ErrorExclamationTriangle as default };
//# sourceMappingURL=ErrorExclamationTriangle.esm.js.map
